import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  EmailShareButton,
  EmailIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import SwiperCore, {
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
} from "swiper";
SwiperCore.use([
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
]);
import "@styles/react/libs/swiper/swiper.scss";

const URL = process.env.REACT_APP_MICRO_MULTIMEDIA_URL;

const VideoGallery = ({ datas, t }) => {
  const shareUrl = window.location.href;
  return (
    <div style={{ position: "sticky", textAlign: "center" }}>
      <div className="mail-body">
        <div className="mail-message">
          <h2 className="text-truncate">{datas?.file_name}</h2>
        </div>
      </div>
      <div className="video-img">
        <video
          width="100%"
          height="450px"
          controls
          src={datas && datas.file_path}
        />
      </div>
      {datas && (
        <div className=" mt-2 mb-0">
          <h3>{t("Share on")} </h3>
          <ul className="blog-icon">
            <li>
              <FacebookShareButton url={shareUrl}>
                <FacebookIcon size={30} round={true} />
              </FacebookShareButton>
            </li>

            <li>
              <TwitterShareButton url={shareUrl}>
                <TwitterIcon size={30} round={true} />
              </TwitterShareButton>
            </li>
            <li>
              <WhatsappShareButton url={shareUrl}>
                <WhatsappIcon size={30} round={true} />
              </WhatsappShareButton>
            </li>
            <li>
              <FacebookMessengerShareButton url={shareUrl}>
                <FacebookMessengerIcon size={30} round={true} />
              </FacebookMessengerShareButton>
            </li>
            <li>
              <EmailShareButton url={shareUrl}>
                <EmailIcon size={30} round={true} />
              </EmailShareButton>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default VideoGallery;
